import Icons from '@/constants/Icons';
import RouteNames from '@/constants/RouteNames';
import AppAction from '@/models/core/AppAction';

export const projectListAction = () =>
  new AppAction({
    icon: Icons.Project,
    name: RouteNames.Project.List,
    route: { name: RouteNames.Project.List },
  });
